import * as React from "react";

export interface ToolbarContextValue {
	orientation: "horizontal" | "vertical";
	itemClassName?: string;
}

export const ToolbarContext = React.createContext<ToolbarContextValue | null>(
	null,
);

export function useToolbarContext() {
	return React.useContext(ToolbarContext);
}
